/**
 * Paths of the entry journey (specs/S3-intro/spec.md §5.2). Proposal, to be validated: the E2 path
 * is the one M1 §5.3 already links to (`homeLinks.telegramLogin`); S4 registers the screen, S5 to
 * S7 add theirs here.
 */
export const ONBOARDING_ROUTES = {
  /** E1 · S3 */
  intro: '/onboarding/intro',
  /** E2 · S4 */
  telegram: '/onboarding/telegram',
  /** E3 · S5. The path Home already links to (`homeLinks.chooseChannels`); S5 registers the screen. */
  channels: '/onboarding/channels',
  /** E4 · S6. The path Home already links to (`homeLinks.tradingAccount`); E3's Continue leads here (S5 R10). */
  tradingAccount: '/onboarding/trading-account',
  /**
   * E5 · S7, provisional on Q21 (step 4 of 4). Proposal, to be validated (S7 R14): outside the tab
   * layout like E1 to E4; E4 leads here after the consent (S6 R17), and the path opens E5 directly.
   */
  firstSettings: '/onboarding/first-settings',
} as const;
